import { diffCalendarDays, parseApiDateOrDateTime } from "./dateParsing"

export const aicaDepartmentFunctions = {
    isStatusHoldAndDaysHavePassed: (aicaData, prefix) => {
        if (aicaData && aicaData[prefix + '_status'] == 2 && aicaData[prefix + '_hold_days'] && aicaData[prefix + '_hold_days'] > 0) {
            const holdDate = parseApiDateOrDateTime(aicaData[prefix + '_updated_at'])
            if (!holdDate) return false

            const diffDays = diffCalendarDays(holdDate, new Date())
            if (diffDays != null && diffDays >= aicaData[prefix + '_hold_days']) {
                return true
            }
        }
        return false
    },

}